import { omit } from 'lodash-es';
import { ConfigConsumerProps } from '../config-provider/configConsumerProps';
export default {
  name: 'FcForm',
  props: {
    // form配置项 包含form
    forms: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  inject: {
    configProvider: { default: () => ConfigConsumerProps }, // 注入依赖，包含组件基本class名方法
  },
  data() {
    return {
      form: this.$form.createForm(this, this.forms.createFormOptions),
    };
  },
  methods: {
    // 按钮点击事件
    click(type, form, index) {
      if (type === 'add') {
        this.$emit('click', 'add', form);
      } else if (type === 'delete') {
        this.$emit('click', 'delete', form, index);
      }
    },
    change(e, item, form, optionsFormIndex, forms) {
      if (item && item.change) {
        item.change(e, item, form, optionsFormIndex, forms);
      }
      this.$emit('change', e, item, form, optionsFormIndex, forms);
    },
    // 校验
    handleSubmit() {
      return new Promise((reslove, reject) => {
        this.form.validateFields((err, values) => {
          if (!err) {
            reslove(values);
          } else {
            reslove('check error!');
          }
        });
      });
    },
    // 单行设置配置值 forms.options|要修改的field|要替换的值
    setFormOpts(forms, field, options) {
      // 遍历 forms 中的每一个 form
      for (let form of forms) {
        // 检查当前 form 是否包含指定的 field
        if (form.form) {
          for (let formItem of form.form) {
            if (formItem.field === field) {
              // 替换该 field 对应的 options 值
              if (formItem.options) {
                formItem.options = options;
              } else {
                formItem['tree-data'] = options;
              }
              break; // 找到并替换后跳出循环
            }
          }
        }
      }
    },
    // 多行设置配置值 forms.options|要修改的forms-field|要修改的forms内的field值|在forms|要替换的值
    setFormsOpts(forms, field, value, index, options) {
      // 遍历 forms 中的每一个 forms
      for (let form of forms) {
        // 检查当前 forms 是否包含指定的 field
        if (form && form.forms && form.field == field) {
          for (let item of form.forms[index]) {
            // 检查子项是否包含指定的 value
            if (item.field === value) {
              // 替换找到的子项的 options 值
              if (item.options) {
                item.options = options;
              } else {
                item['tree-data'] = options;
              }
              break; // 找到并替换后跳出循环
            }
          }
        }
      }
    },
    //单行的form增加一个设置禁用方法
    setFormStatus(forms, fieldArr, type, value) {
      // 遍历 forms 中的每一个 form
      for (let form of forms) {
        // 检查当前 form 是否包含指定的 field
        if (form.form) {
          for (let formItem of form.form) {
            if (fieldArr.includes(formItem.field)) {
              // 替换该 field 对应的 options 值
              formItem[type] = value;
              // break; // 找到并替换后跳出循环
            }
          }
        }
      }
    },
    // fieldArr为key-Value形式
    setFormsStatus(forms, fieldMap, type, value) {
      // 遍历 forms 中的每一个 forms
      const keys = Object.keys(fieldMap);
      for (let form of forms) {
        // 检查当前 forms 是否包含指定的 field
        if (form && form.forms && keys.includes(form.field)) {
          for (let index = 0; index < form.forms.length; index++) {
            for (let item of form.forms[index]) {
              // 检查子项是否包含指定的 value
              if (item.field == fieldMap[form.field]) {
                // 替换找到的子项的 options 值
                item[type] = value;
              }
              // break; // 找到并替换后跳出循环
            }
          }
        }
      }
    },
    // 针对formsValue的回显值
    setFormsItem(forms, field, values) {
      // 遍历 forms 中的每一个 forms
      for (let form of forms) {
        // 检查当前 forms 是否包含指定的 field
        if (form && form.forms && form.field == field) {
          form.forms = [form.forms[0]];
          let i = 1;
          while (i < values.length) {
            form.forms.push(form.forms[0]);
            i++;
          }
        }
      }
    },
    // forms的标识|下标|要修改的field[]
    clearValue(field, index, childFilds) {
      this.$nextTick(() => {
        let data = {};
        data[field] = this.form.getFieldsValue()[field];
        childFilds.forEach(c => {
          data[field][index][c] = undefined;
        });
        this.form.setFieldsValue(data);
      });
    },
    resetFields() {
      this.form.resetFields();
    },
    // form赋值
    setFieldsValue(data) {
      // setTimeout(() => {
      this.form.setFieldsValue(data);
      // })
    },
  },
  mounted() {},
  render() {
    let { forms, form, $slots, $scopedSlots, _props, $attrs } = this;
    const { style } = _props;
    const { getPrefixCls, locale } = this.configProvider;
    const prefixCls = getPrefixCls('', 'fc-form');
    return (
      forms.options &&
      forms.options.length > 0 && (
        <div class={`${prefixCls}`} style={style}>
          <a-form
            layout="inline"
            {...{ props: omit($attrs, 'options') }}
            form={forms.form || form}
            label-col={forms.labelCol ? forms.labelCol : { span: 5 }}
            wrapper-col={forms.wrapperCol ? forms.wrapperCol : { span: 18 }}
            class={`${prefixCls}-main`}
          >
            {forms.options.map(
              (option, formIndex) =>
                (option.forms || option.form) && (
                  <a-row key={formIndex} style={{ marginBottom: `${forms.space || 0}px` }}>
                    {/* forms!!--------------------------- */}
                    {!!option.forms &&
                      option.forms.map(
                        (form, optionsFormIndex) =>
                          form.filter(cc => cc.show == undefined || cc.show).length > 0 && (
                            <div
                              class={`${prefixCls}-main-line`}
                              style={{
                                marginBottom: `${
                                  forms.options.length - 1 == formIndex &&
                                  option.forms.length - 1 == optionsFormIndex
                                    ? '0'
                                    : forms.space || 24
                                }px`,
                              }}
                            >
                              <div class={`${prefixCls}-main-line-component`}>
                                {form.map((item, index) => {
                                  const fieldName = `${option.field}[${optionsFormIndex}].${item.field}`;
                                  return (
                                    (item.show === undefined || item.show) && (
                                      <a-col
                                        span={
                                          item.span ||
                                          24 /
                                            form.filter(cc => cc.show == undefined || cc.show)
                                              .length
                                        }
                                        class={`${prefixCls}-main-line-component-col`}
                                        key={fieldName}
                                        style={{
                                          marginTop: `${item.top || 0}px`,
                                        }}
                                      >
                                        {
                                          <a-form-item
                                            colon={false}
                                            // {...(item.tip ? {} : { label: item.label || null })}
                                            label-col={item.labelCol || form.labelCol}
                                            wrapper-col={
                                              item.wrapperCol
                                                ? item.wrapperCol
                                                : form.wrapperCol
                                                ? form.wrapperCol
                                                : { span: 24 }
                                            }
                                            class={`${prefixCls}-main-line-component-col-formitem ${
                                              index !== 0 ? 'hiddenLabel' : ''
                                            }`}
                                          >
                                            {optionsFormIndex === 0 &&
                                            (item.label || item.labelCol) &&
                                            (item.show === undefined || item.show) ? (
                                              <span slot="label">
                                                <span>
                                                  {item.label}&nbsp;
                                                  {item.tip && (
                                                    <a-tooltip title={item.tip}>
                                                      {$slots[item.field] && (
                                                        <template slot={item.field}>
                                                          {$slots[item.field]}
                                                        </template>
                                                      )}
                                                      <a-icon type="question-circle-o" />
                                                    </a-tooltip>
                                                  )}
                                                </span>
                                              </span>
                                            ) : !item.labelCol ? null : !item.labelCol
                                                .span ? null : item.labelCol.span === 24 ? null : (
                                              <span slot="label"></span>
                                            )}
                                            {(item.show === undefined || item.show) &&
                                              item.type === 'input' && (
                                                <a-row
                                                  style={
                                                    index === form.length - 1
                                                      ? `width: calc(100% - 42px)`
                                                      : ''
                                                  }
                                                >
                                                  <a-col
                                                    span={24}
                                                    class={`${prefixCls}-main-line-component-col-formitem-col`}
                                                    style={{
                                                      width: `calc(100% - ${item.right}px)`,
                                                    }}
                                                  >
                                                    <a-input
                                                      {...{ props: item }}
                                                      {...{ on: omit(item, 'change') }}
                                                      onChange={e => {
                                                        this.change(
                                                          e,
                                                          item,
                                                          form,
                                                          optionsFormIndex,
                                                          option.forms,
                                                        );
                                                      }}
                                                      v-decorator={[
                                                        fieldName,
                                                        { rules: item.rules },
                                                      ]}
                                                      v-show={
                                                        item.toggle || item.toggle === undefined
                                                      }
                                                      placeholder={item.placeholder}
                                                      key={optionsFormIndex}
                                                      class={`${prefixCls}-main-line-component-col-formitem-item`}
                                                    />
                                                    <span
                                                      class={`${prefixCls}-main-line-component-col-formitem-item-toggle`}
                                                      v-show={item.hasOwnProperty('toggle')}
                                                      style={
                                                        item.toggleColor
                                                          ? { color: item.toggleColor }
                                                          : { color: '#165DFF' }
                                                      }
                                                      onClick={() => {
                                                        if (item.toggle !== undefined) {
                                                          item.toggle = !item.toggle;
                                                        }
                                                        if (item.toggleHandler) {
                                                          item.toggleHandler(item);
                                                        }
                                                      }}
                                                    >
                                                      {item.toggleText || '切换控件'}
                                                    </span>
                                                  </a-col>
                                                </a-row>
                                              )}
                                            {(item.show === undefined || item.show) &&
                                              item.type === 'select' && (
                                                <a-row
                                                  style={
                                                    index === form.length - 1
                                                      ? `width: calc(100% - 42px)`
                                                      : ''
                                                  }
                                                >
                                                  <a-col
                                                    span={24}
                                                    style={{
                                                      width: `calc(100% - ${item.right}px)`,
                                                    }}
                                                  >
                                                    <a-select
                                                      {...{ props: omit(item, 'options') }}
                                                      {...{ on: omit(item, 'change') }}
                                                      onChange={value => {
                                                        if (option.mutex) {
                                                          let fields = [];
                                                          option.forms.forEach(group => {
                                                            group.forEach(item => {
                                                              if (item.type === 'select') {
                                                                fields.push(item.field);
                                                              }
                                                            });
                                                          });
                                                          this.$nextTick(() => {
                                                            const data = this.form.getFieldsValue()[
                                                              option.field
                                                            ];
                                                            const selectedValues = data.flatMap(
                                                              item =>
                                                                fields.flatMap(field =>
                                                                  item[field] !== undefined
                                                                    ? [item[field]]
                                                                    : [],
                                                                ),
                                                            );
                                                            this.$set(
                                                              option,
                                                              'selected',
                                                              selectedValues,
                                                            );
                                                          });
                                                        }
                                                        this.change(
                                                          value,
                                                          item,
                                                          form,
                                                          optionsFormIndex,
                                                          option.forms,
                                                        );
                                                      }}
                                                      v-decorator={[
                                                        fieldName,
                                                        { rules: item.rules },
                                                      ]}
                                                      placeholder={item.placeholder}
                                                      class={`${prefixCls}-main-line-component-col-formitem-item`}
                                                      notFoundContent={
                                                        <span class="ant-select-not-found"></span>
                                                      }
                                                    >
                                                      {item.options.map((o, index) => {
                                                        return (
                                                          <a-select-option
                                                            key={item.value}
                                                            value={o.value}
                                                            disabled={
                                                              o.disabled ||
                                                              (option.selected &&
                                                                option.selected.includes(o.value))
                                                            }
                                                            {...{ props: omit(o, 'disabled') }}
                                                          >
                                                            {o.label}
                                                          </a-select-option>
                                                        );
                                                      })}
                                                    </a-select>
                                                  </a-col>
                                                </a-row>
                                              )}
                                            {(item.show === undefined || item.show) &&
                                              item.type === 'radio' && (
                                                <a-row
                                                  style={
                                                    index === form.length - 1
                                                      ? `width: calc(100% - 42px)`
                                                      : ''
                                                  }
                                                >
                                                  <a-col
                                                    span={24}
                                                    style={{
                                                      width: `calc(100% - ${item.right}px)`,
                                                    }}
                                                  >
                                                    <a-radio-group
                                                      {...{ props: item }}
                                                      {...{ on: omit(item, 'change') }}
                                                      onChange={value => {
                                                        this.change(
                                                          value,
                                                          item,
                                                          form,
                                                          optionsFormIndex,
                                                          option.forms,
                                                        );
                                                      }}
                                                      v-decorator={[
                                                        fieldName,
                                                        { rules: item.rules },
                                                      ]}
                                                      key={item.field}
                                                      class={`${prefixCls}-main-line-component-col-formitem-item`}
                                                    >
                                                      {item.options.map((option, index) => {
                                                        return (
                                                          <a-radio value={option.value}>
                                                            {option.label}
                                                          </a-radio>
                                                        );
                                                      })}
                                                    </a-radio-group>
                                                  </a-col>
                                                </a-row>
                                              )}
                                            {(item.show === undefined || item.show) &&
                                              item.type === 'textarea' && (
                                                <a-row
                                                  style={
                                                    index === form.length - 1
                                                      ? `width: calc(100% - 42px)`
                                                      : ''
                                                  }
                                                >
                                                  <a-col
                                                    span={24}
                                                    style={{
                                                      width: `calc(100% - ${item.right}px)`,
                                                    }}
                                                  >
                                                    <a-textarea
                                                      {...{ props: item }}
                                                      {...{ on: omit(item, 'change') }}
                                                      onChange={value => {
                                                        this.change(
                                                          value,
                                                          item,
                                                          form,
                                                          optionsFormIndex,
                                                          option.forms,
                                                        );
                                                      }}
                                                      v-decorator={[
                                                        fieldName,
                                                        { rules: item.rules },
                                                      ]}
                                                      placeholder={item.placeholder}
                                                      key={item.field}
                                                      class={`${prefixCls}-main-line-component-col-formitem-item`}
                                                    />
                                                  </a-col>
                                                </a-row>
                                              )}
                                            {(item.show === undefined || item.show) &&
                                              item.type === 'treeSelect' && (
                                                <a-row
                                                  style={
                                                    index === form.length - 1
                                                      ? `width: calc(100% - 42px)`
                                                      : ''
                                                  }
                                                >
                                                  <a-col
                                                    span={24}
                                                    style={{
                                                      width: `calc(100% - ${item.right}px)`,
                                                    }}
                                                  >
                                                    <a-tree-select
                                                      {...{ props: item }}
                                                      {...{ on: omit(item, 'change') }}
                                                      onChange={value => {
                                                        this.change(
                                                          value,
                                                          item,
                                                          form,
                                                          optionsFormIndex,
                                                          option.forms,
                                                        );
                                                      }}
                                                      v-decorator={[
                                                        fieldName,
                                                        { rules: item.rules },
                                                      ]}
                                                      key={item.field}
                                                      class={`${prefixCls}-main-line-component-col-formitem-item`}
                                                    />
                                                  </a-col>
                                                </a-row>
                                              )}
                                            {(item.show === undefined || item.show) &&
                                              item.type === 'cascader' && (
                                                <a-row
                                                  style={
                                                    index === form.length - 1
                                                      ? `width: calc(100% - 42px)`
                                                      : ''
                                                  }
                                                >
                                                  <a-col
                                                    span={24}
                                                    style={{
                                                      width: `calc(100% - ${item.right}px)`,
                                                    }}
                                                  >
                                                    <a-cascader
                                                      {...{ props: item }}
                                                      {...{ on: omit(item, 'change') }}
                                                      onChange={value => {
                                                        this.change(
                                                          value,
                                                          item,
                                                          form,
                                                          optionsFormIndex,
                                                          option.forms,
                                                        );
                                                      }}
                                                      v-decorator={[
                                                        fieldName,
                                                        { rules: item.rules },
                                                      ]}
                                                      key={item.field}
                                                      notFoundContent={
                                                        <span class="ant-select-not-found"></span>
                                                      }
                                                      class={`${prefixCls}-main-line-component-col-formitem-item`}
                                                    />
                                                  </a-col>
                                                </a-row>
                                              )}
                                            {(item.show === undefined || item.show) &&
                                              item.type === 'inputNumber' && (
                                                <a-row
                                                  style={
                                                    index === form.length - 1
                                                      ? `width: calc(100% - 42px)`
                                                      : ''
                                                  }
                                                >
                                                  <a-col
                                                    span={24}
                                                    style={{
                                                      width: `calc(100% - ${item.right}px)`,
                                                    }}
                                                  >
                                                    <a-input-number
                                                      {...{ props: item }}
                                                      {...{ on: omit(item, 'change') }}
                                                      onChange={value => {
                                                        this.change(
                                                          value,
                                                          item,
                                                          form,
                                                          optionsFormIndex,
                                                          option.forms,
                                                        );
                                                      }}
                                                      v-decorator={[
                                                        fieldName,
                                                        { rules: item.rules },
                                                      ]}
                                                      key={item.field}
                                                      class={`${prefixCls}-main-line-component-col-formitem-item`}
                                                    />
                                                  </a-col>
                                                </a-row>
                                              )}
                                            {(item.show === undefined || item.show) &&
                                              item.type === 'datePicker' && (
                                                <a-row
                                                  style={
                                                    index === form.length - 1
                                                      ? `width: calc(100% - 42px)`
                                                      : ''
                                                  }
                                                >
                                                  <a-col
                                                    span={24}
                                                    style={{
                                                      width: `calc(100% - ${item.right}px)`,
                                                    }}
                                                  >
                                                    <a-date-picker
                                                      {...{ props: item }}
                                                      {...{ on: omit(item, 'change') }}
                                                      onChange={value => {
                                                        this.change(
                                                          value,
                                                          item,
                                                          form,
                                                          optionsFormIndex,
                                                          option.forms,
                                                        );
                                                      }}
                                                      v-decorator={[
                                                        fieldName,
                                                        { rules: item.rules },
                                                      ]}
                                                      key={item.field}
                                                      class={`${prefixCls}-main-line-component-col-formitem-item`}
                                                    />
                                                  </a-col>
                                                </a-row>
                                              )}
                                            {(item.show === undefined || item.show) &&
                                              item.type === 'timePicker' && (
                                                <a-row
                                                  style={
                                                    index === form.length - 1
                                                      ? `width: calc(100% - 42px)`
                                                      : ''
                                                  }
                                                >
                                                  <a-col
                                                    span={24}
                                                    style={{
                                                      width: `calc(100% - ${item.right}px)`,
                                                    }}
                                                  >
                                                    <a-time-picker
                                                      {...{ props: item }}
                                                      {...{ on: omit(item, 'change') }}
                                                      onChange={value => {
                                                        this.change(
                                                          value,
                                                          item,
                                                          form,
                                                          optionsFormIndex,
                                                          option.forms,
                                                        );
                                                      }}
                                                      v-decorator={[
                                                        fieldName,
                                                        { rules: item.rules },
                                                      ]}
                                                      key={item.field}
                                                      class={`${prefixCls}-main-line-component-col-formitem-item`}
                                                    />
                                                  </a-col>
                                                </a-row>
                                              )}
                                            {(item.show === undefined || item.show) &&
                                              item.type === 'upload' && (
                                                <a-row
                                                  style={
                                                    index === form.length - 1
                                                      ? `width: calc(100% - 42px)`
                                                      : ''
                                                  }
                                                >
                                                  <a-col
                                                    span={24}
                                                    class={`${prefixCls}-main-line-component-col-formitem-col`}
                                                    style={{
                                                      width: `calc(100% - ${item.right}px)`,
                                                    }}
                                                  >
                                                    {(item.show || item.show === undefined) &&
                                                      (item.toggle ||
                                                        item.toggle === undefined) && (
                                                        <fc-upload
                                                          {...{ props: item.options.props }}
                                                          {...{
                                                            on: omit(item.options.on, 'change'),
                                                          }}
                                                          onChange={info => {
                                                            // this.$emit('change', info);
                                                            if (item.options.on.change) {
                                                              item.options.on.change(info);
                                                            }
                                                            this.form.setFieldsValue({
                                                              fieldName: info,
                                                            });
                                                          }}
                                                          onDeleteFile={info => {
                                                            this.$emit('deleteFile', info);
                                                            this.form.setFieldsValue({
                                                              fieldName: info.fileList,
                                                            });
                                                          }}
                                                          v-decorator={[
                                                            fieldName,
                                                            { rules: item.rules },
                                                          ]}
                                                          class={`${prefixCls}-main-line-component-col-formitem-item`}
                                                          style={
                                                            item.toggle
                                                              ? { width: 'calc(100% - 60px)' }
                                                              : {}
                                                          }
                                                        >
                                                          <template slot="content">
                                                            <a-button
                                                              {...{ props: omit(item, 'type') }}
                                                            >
                                                              {item.text}
                                                            </a-button>
                                                          </template>
                                                        </fc-upload>
                                                      )}
                                                    <span
                                                      class={`${prefixCls}-main-line-component-col-formitem-item-toggle`}
                                                      v-show={item.hasOwnProperty('toggle')}
                                                      style={
                                                        item.toggleColor
                                                          ? { color: item.toggleColor }
                                                          : { color: '#165DFF' }
                                                      }
                                                      onClick={() => {
                                                        if (item.toggle !== undefined) {
                                                          item.toggle = !item.toggle;
                                                        }
                                                        if (item.toggleHandler) {
                                                          item.toggleHandler(item);
                                                        }
                                                      }}
                                                    >
                                                      {item.toggleText || '切换控件'}
                                                    </span>
                                                  </a-col>
                                                </a-row>
                                              )}
                                            {(item.show === undefined || item.show) &&
                                              item.type === 'html' && (
                                                <a-row
                                                  style={
                                                    index === form.length - 1
                                                      ? `width: calc(100% - 42px)`
                                                      : ''
                                                  }
                                                >
                                                  <a-col
                                                    span={24}
                                                    style={{
                                                      width: `calc(100% - ${item.right}px)`,
                                                    }}
                                                  >
                                                    <div
                                                      {...{
                                                        domProps: {
                                                          innerHTML: item.content,
                                                        },
                                                      }}
                                                    ></div>
                                                  </a-col>
                                                </a-row>
                                              )}
                                            {(item.show === undefined || item.show) &&
                                              item.type === 'slot' && (
                                                <a-row
                                                  style={
                                                    index === form.length - 1
                                                      ? `width: calc(100% - 42px)`
                                                      : ''
                                                  }
                                                >
                                                  <a-col
                                                    span={24}
                                                    style={{
                                                      width: `calc(100% - ${item.right}px)`,
                                                    }}
                                                  >
                                                    {$scopedSlots[item.slotName](item)}
                                                  </a-col>
                                                </a-row>
                                              )}
                                          </a-form-item>
                                        }
                                      </a-col>
                                    )
                                  );
                                })}
                              </div>
                              {form.length > 0 &&
                                form.filter(
                                  showCount => showCount.sow === undefined || showCount.show,
                                ).length > 0 &&
                                option.show != false && (
                                  <div class={`${prefixCls}-icons`}>
                                    <div
                                      class={`${prefixCls}-icons-icon`}
                                      onClick={() => {
                                        if (
                                          !option.disabled &&
                                          (!option.limit ||
                                            (option.limit &&
                                              option.limit >
                                                option.forms.filter(subArray => subArray.length > 0)
                                                  .length))
                                        ) {
                                          this.click('add', option);
                                        }
                                      }}
                                    >
                                      <a-icon
                                        type="plus-circle"
                                        style={
                                          !option.disabled &&
                                          (!option.limit ||
                                            (option.limit &&
                                              option.limit >
                                                option.forms.filter(subArray => subArray.length > 0)
                                                  .length))
                                            ? { color: '#4E5969' }
                                            : { color: '#C9CDD4', cursor: 'not-allowed' }
                                        }
                                      />
                                    </div>
                                    <div
                                      class={`${prefixCls}-icons-icon`}
                                      onClick={() => {
                                        if (
                                          !option.disabled &&
                                          option.forms.filter(subArray => subArray.length > 0)
                                            .length > 1
                                        ) {
                                          let newVal = this.form.getFieldsValue()[option.field];
                                          newVal.splice(optionsFormIndex, 1);
                                          this.form.setFieldsValue({ [option.field]: newVal });
                                          this.click('delete', option, optionsFormIndex);
                                        }
                                      }}
                                    >
                                      <a-icon
                                        type="minus-circle"
                                        style={
                                          !option.disabled &&
                                          option.forms.filter(subArray => subArray.length > 0)
                                            .length > 1
                                            ? { color: '#4E5969' }
                                            : { color: '#C9CDD4', cursor: 'not-allowed' }
                                        }
                                      />
                                    </div>
                                  </div>
                                )}
                            </div>
                          ),
                      )}
                    {/* form!!-------------------------------------- */}
                    <div class={`${prefixCls}-singleLine`}>
                      {option.form &&
                        option.form.filter(cc => cc.show == undefined || cc.show).length > 0 &&
                        option.form.map(
                          (item, index) =>
                            (item.show === undefined || item.show) && (
                              <a-col
                                span={
                                  item.span ||
                                  24 /
                                    option.form.filter(cc => cc.show == undefined || cc.show).length
                                }
                                class={`${prefixCls}-main-line-component-col ${prefixCls}-main-line-component-col-form`}
                                key={item.field}
                                style={{
                                  marginTop: `${item.top || 0}px`,
                                  marginBottom: `${
                                    forms.options.length - 1 == formIndex ? '0' : forms.space || 24
                                  }px`,
                                }}
                              >
                                {
                                  <a-form-item
                                    colon={false}
                                    label-col={item.labelCol || forms.labelCol}
                                    wrapper-col={
                                      item.wrapperCol
                                        ? item.wrapperCol
                                        : forms.wrapperCol
                                        ? forms.wrapperCol
                                        : { span: 24 }
                                    }
                                    class={`${prefixCls}-main-line-component-col-formitem`}
                                  >
                                    {(item.show === undefined || item.show) && item.label ? (
                                      <span slot="label">
                                        {item.label}&nbsp;
                                        {$slots[item.field] && (
                                          <a-tooltip>
                                            {$slots[item.field] && (
                                              <template slot="title">{$slots[item.field]}</template>
                                            )}
                                            <a-icon type="question-circle-o" />
                                          </a-tooltip>
                                        )}
                                        {!$slots[item.field] && item.tip && (
                                          <a-tooltip title={item.tip}>
                                            <a-icon type="question-circle-o" />
                                          </a-tooltip>
                                        )}
                                      </span>
                                    ) : null}

                                    {(item.show === undefined || item.show) &&
                                      item.type === 'input' && (
                                        <a-row>
                                          <a-col
                                            span={24}
                                            class={`${prefixCls}-main-line-component-col-formitem-col`}
                                            style={{
                                              width: `calc(100% - ${item.right}px)`,
                                            }}
                                          >
                                            <a-input
                                              {...{ props: item }}
                                              {...{ on: omit(item, 'change') }}
                                              onChange={e => {
                                                this.change(e, item);
                                              }}
                                              v-decorator={[item.field, { rules: item.rules }]}
                                              v-show={item.toggle || item.toggle === undefined}
                                              placeholder={item.placeholder}
                                              key={item.field}
                                              class={`${prefixCls}-main-line-component-col-formitem-item`}
                                            />
                                            <span
                                              class={`${prefixCls}-main-line-component-col-formitem-item-toggle`}
                                              v-show={item.hasOwnProperty('toggle')}
                                              style={
                                                item.toggleColor
                                                  ? { color: item.toggleColor }
                                                  : { color: '#165DFF' }
                                              }
                                              onClick={() => {
                                                if (item.toggle !== undefined) {
                                                  item.toggle = !item.toggle;
                                                }
                                                if (item.toggleHandler) {
                                                  item.toggleHandler(item);
                                                }
                                              }}
                                            >
                                              {item.toggleText || locale.Form.switchControl}
                                            </span>
                                          </a-col>
                                        </a-row>
                                      )}

                                    {(item.show === undefined || item.show) &&
                                      item.type === 'select' && (
                                        <a-row>
                                          <a-col
                                            span={24}
                                            style={{
                                              width: `calc(100% - ${item.right}px)`,
                                            }}
                                          >
                                            <a-select
                                              {...{ props: item }}
                                              {...{ on: omit(item, 'change') }}
                                              onChange={value => {
                                                this.change(value, item);
                                              }}
                                              v-decorator={[item.field, { rules: item.rules }]}
                                              placeholder={item.placeholder}
                                              class={`${prefixCls}-main-line-component-col-formitem-item`}
                                              notFoundContent={
                                                <span class="ant-select-not-found"></span>
                                              }
                                            >
                                              {item.options.map((option, index) => {
                                                return (
                                                  <a-select-option
                                                    key={item.field}
                                                    value={option.value}
                                                    {...{ props: option }}
                                                  >
                                                    {option.label}
                                                  </a-select-option>
                                                );
                                              })}
                                            </a-select>
                                          </a-col>
                                        </a-row>
                                      )}
                                    {(item.show === undefined || item.show) &&
                                      item.type === 'radio' && (
                                        <a-row>
                                          <a-col
                                            span={24}
                                            style={{
                                              width: `calc(100% - ${item.right}px)`,
                                            }}
                                          >
                                            <a-radio-group
                                              {...{ props: item }}
                                              {...{ on: item }}
                                              v-decorator={[item.field, { rules: item.rules }]}
                                              key={item.field}
                                              class={`${prefixCls}-main-line-component-col-formitem-item`}
                                            >
                                              {item.options.map((option, index) => {
                                                return (
                                                  <a-radio value={option.value}>
                                                    {option.label}
                                                  </a-radio>
                                                );
                                              })}
                                            </a-radio-group>
                                          </a-col>
                                        </a-row>
                                      )}
                                    {(item.show === undefined || item.show) &&
                                      item.type === 'textarea' && (
                                        <a-row>
                                          <a-col
                                            span={24}
                                            style={{
                                              width: `calc(100% - ${item.right}px)`,
                                            }}
                                          >
                                            <a-textarea
                                              {...{ props: item }}
                                              {...{ on: omit(item, 'change') }}
                                              onChange={value => {
                                                this.change(value, item);
                                              }}
                                              v-decorator={[item.field, { rules: item.rules }]}
                                              placeholder={item.placeholder}
                                              key={item.field}
                                              class={`${prefixCls}-main-line-component-col-formitem-item`}
                                            />
                                          </a-col>
                                        </a-row>
                                      )}
                                    {(item.show === undefined || item.show) &&
                                      item.type === 'treeSelect' && (
                                        <a-row>
                                          <a-col
                                            span={24}
                                            style={{
                                              width: `calc(100% - ${item.right}px)`,
                                            }}
                                          >
                                            <a-tree-select
                                              {...{ props: item }}
                                              {...{ on: omit(item, 'change') }}
                                              onChange={value => {
                                                this.change(value, item);
                                              }}
                                              v-decorator={[item.field, { rules: item.rules }]}
                                              key={item.field}
                                              class={`${prefixCls}-main-line-component-col-formitem-item`}
                                            />
                                          </a-col>
                                        </a-row>
                                      )}
                                    {(item.show === undefined || item.show) &&
                                      item.type === 'cascader' && (
                                        <a-row>
                                          <a-col
                                            span={24}
                                            style={{
                                              width: `calc(100% - ${item.right}px)`,
                                            }}
                                          >
                                            <a-cascader
                                              {...{ props: item }}
                                              {...{ on: omit(item, 'change') }}
                                              onChange={value => {
                                                this.change(value, item);
                                              }}
                                              notFoundContent={
                                                <span class="ant-select-not-found"></span>
                                              }
                                              v-decorator={[item.field, { rules: item.rules }]}
                                              key={item.field}
                                              class={`${prefixCls}-main-line-component-col-formitem-item`}
                                            />
                                          </a-col>
                                        </a-row>
                                      )}
                                    {(item.show === undefined || item.show) &&
                                      item.type === 'inputNumber' && (
                                        <a-row>
                                          <a-col
                                            span={24}
                                            style={{
                                              width: `calc(100% - ${item.right}px)`,
                                            }}
                                          >
                                            <a-input-number
                                              {...{ props: item }}
                                              {...{ on: omit(item, 'change') }}
                                              onChange={value => {
                                                this.change(value, item, form);
                                              }}
                                              v-decorator={[item.field, { rules: item.rules }]}
                                              key={item.field}
                                              class={`${prefixCls}-main-line-component-col-formitem-item`}
                                            />
                                          </a-col>
                                        </a-row>
                                      )}
                                    {(item.show === undefined || item.show) &&
                                      item.type === 'datePicker' && (
                                        <a-row>
                                          <a-col
                                            span={24}
                                            style={{
                                              width: `calc(100% - ${item.right}px)`,
                                            }}
                                          >
                                            <a-date-picker
                                              {...{ props: item }}
                                              {...{ on: omit(item, 'change') }}
                                              onChange={value => {
                                                this.change(value, item, form);
                                              }}
                                              v-decorator={[item.field, { rules: item.rules }]}
                                              key={item.field}
                                              class={`${prefixCls}-main-line-component-col-formitem-item`}
                                            />
                                          </a-col>
                                        </a-row>
                                      )}
                                    {(item.show === undefined || item.show) &&
                                      item.type === 'timePicker' && (
                                        <a-row>
                                          <a-col
                                            span={24}
                                            style={{
                                              width: `calc(100% - ${item.right}px)`,
                                            }}
                                          >
                                            <a-time-picker
                                              {...{ props: item }}
                                              {...{ on: omit(item, 'change') }}
                                              onChange={value => {
                                                this.change(value, item, form);
                                              }}
                                              v-decorator={[item.field, { rules: item.rules }]}
                                              key={item.field}
                                              class={`${prefixCls}-main-line-component-col-formitem-item`}
                                            />
                                          </a-col>
                                        </a-row>
                                      )}
                                    {(item.show === undefined || item.show) &&
                                      item.type === 'upload' && (
                                        <a-row>
                                          <a-col
                                            span={24}
                                            class={`${prefixCls}-main-line-component-col-formitem-col`}
                                            style={{
                                              width: `calc(100% - ${item.right}px)`,
                                            }}
                                          >
                                            {(item.show || item.show === undefined) &&
                                              (item.toggle || item.toggle === undefined) && (
                                                <fc-upload
                                                  {...{ props: item.options.props }}
                                                  {...{ on: omit(item.options.on, 'change') }}
                                                  onChange={info => {
                                                    // this.$emit('change', info);
                                                    if (item.options.on.change) {
                                                      item.options.on.change(info);
                                                    }
                                                    this.form.setFieldsValue({
                                                      [item.field]: info,
                                                    });
                                                  }}
                                                  onDeleteFile={info => {
                                                    this.$emit('deleteFile', info);
                                                    this.form.setFieldsValue({
                                                      [item.field]: info.fileList,
                                                    });
                                                  }}
                                                  v-decorator={[item.field, { rules: item.rules }]}
                                                  class={`${prefixCls}-main-line-component-col-formitem-item`}
                                                  style={
                                                    item.toggle
                                                      ? { width: 'calc(100% - 60px)' }
                                                      : {}
                                                  }
                                                >
                                                  <template slot="content">
                                                    <a-button {...{ props: item }}>
                                                      {item.text}
                                                    </a-button>
                                                  </template>
                                                  <template slot="tag">{$slots.tag}</template>
                                                </fc-upload>
                                              )}
                                            <span
                                              class={`${prefixCls}-main-line-component-col-formitem-item-toggle`}
                                              v-show={item.hasOwnProperty('toggle')}
                                              style={
                                                item.toggleColor
                                                  ? { color: item.toggleColor }
                                                  : { color: '#165DFF' }
                                              }
                                              onClick={() => {
                                                if (item.toggle !== undefined) {
                                                  item.toggle = !item.toggle;
                                                }
                                                if (item.toggleHandler) {
                                                  item.toggleHandler(item);
                                                }
                                              }}
                                            >
                                              {item.toggleText || '切换控件'}
                                            </span>
                                          </a-col>
                                        </a-row>
                                      )}
                                    {(item.show === undefined || item.show) &&
                                      item.type === 'html' && (
                                        <a-row>
                                          <a-col
                                            span={24}
                                            style={{
                                              width: `calc(100% - ${item.right}px)`,
                                            }}
                                          >
                                            <div
                                              {...{
                                                domProps: {
                                                  innerHTML: item.content,
                                                },
                                              }}
                                            ></div>
                                          </a-col>
                                        </a-row>
                                      )}
                                    {(item.show === undefined || item.show) &&
                                      item.type === 'slot' && (
                                        <a-row>
                                          <a-col
                                            span={24}
                                            style={{
                                              width: `calc(100% - ${item.right}px)`,
                                            }}
                                          >
                                            {/* {$slots[item.slotName]} */}
                                            {$scopedSlots[item.slotName](item)}
                                          </a-col>
                                        </a-row>
                                      )}
                                  </a-form-item>
                                }
                              </a-col>
                            ),
                        )}
                    </div>
                  </a-row>
                ),
            )}
          </a-form>
        </div>
      )
    );
  },
};
